import Model from '../Model'

export default class SentEstimate extends Model {
    static async all(from, to, sentBy) {
        const params = {from: from, to: to, sentBy: sentBy}
        const data = await Http.get(route('api.v2.reporting.sentEstimates.report'), {params})
        return this.make(data)
    }
}
